import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import reducers from "../reducers";

const initialState = {};

export const configureStore = (preloadedState = initialState) => {
    const enhancer =
        process.env.NODE_ENV !== "production" && window.__REDUX_DEVTOOLS_EXTENSION__
            ? compose(applyMiddleware(thunk), window.__REDUX_DEVTOOLS_EXTENSION__())
            : applyMiddleware(thunk);

    return createStore(reducers, preloadedState, enhancer);
};

const store = configureStore();

export default store;
